module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"video.js","commonjs2":"video.js","amd":"video.js","root":"videojs"}
// module id = 1
// module chunks = 0